import Skeleton from "../../../components/Skeleton/Skeleton";
import TableSkeleton from "../../../components/Skeleton/ui/TableSkeleton/TableSkeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <div className="flex flex-col gap-4">
        {/* Tabs */}
        <div className="flex border-b border-[#EBEBEB]">
          <Skeleton height="24px" className="mb-3 mr-8 flex-1" />
          <Skeleton height="24px" className="mb-3 flex-1" />
        </div>

        {/* Dropdowns */}
        <div className="flex gap-3">
          <Skeleton height="48px" borderRadius="0.5rem" className="flex-1" />
          <Skeleton height="48px" borderRadius="0.5rem" className="flex-1" />
        </div>

        {/* Search bar */}
        <Skeleton width="100%" height="44px" borderRadius="0.5rem" />

        <TableSkeleton numberOfColumns={2} numberOfRows={5} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 h-full min-h-[100vh]">
      <Skeleton width="228.933px" height="32px" />

      <div className="flex items-center justify-between">
        <div className="flex gap-4">
          <Skeleton width="301px" height="32px" />
          <Skeleton width="166.883px" height="32px" />
        </div>
        <Skeleton width="528px" height="43px" />
      </div>

      <TableSkeleton numberOfColumns={3} numberOfRows={10} />
    </div>
  );
};

export default PageSkeleton;
